var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('fw-receipt',{attrs:{"is_my":true,"receipt":_vm.receipt},on:{"postMessage":_vm.postMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }